import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import ModalHeader from 'components/Modal/Header';
import { useLocation } from 'react-router-dom';

import { Notification } from '@shoflo/polymer';
import {
  StyledButton,
  StyledModalFooter
} from './LostRealtimeSocketMessageModal.styled';

import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/ModalTypes';

export const LostRealtimeSocketMessageModal = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === LOST_REALTIME_SOCKET_CONNECTION
  );

  const location = useLocation();
  const isScenePreview = location.pathname.includes('/scene');

  let isValidView = true;

  if (isScenePreview) {
    isValidView = false;
  }

  return (
    <Modal isOpen={isOpen && isValidView}>
      <ModalHeader>Lost realtime connection to Studio</ModalHeader>
      <ModalBody>
        <p>
          Your realtime connection is required to send program updates to
          streams & presenters.
          <strong>&nbsp; All streams & records will continue.</strong>
        </p>
        <p>
          Check your internet connection and refresh the page if the connection
          is not restored. Refresh will not disrupt stream / records.
        </p>
        <Notification
          message="Attempting to re-connect..."
          type="warning"
          isDismissible={false}
        />
      </ModalBody>
      <StyledModalFooter>
        <StyledButton onClick={() => window.location.reload()}>
          Refresh the page
        </StyledButton>
      </StyledModalFooter>
    </Modal>
  );
};

export default LostRealtimeSocketMessageModal;
